const firebaseConfig = {
  apiKey: "AIzaSyCN6L46CqLiGgd89cQjYhNHLD3m67UHLE8",
  authDomain: "tour-the-world12.firebaseapp.com",
  projectId: "tour-the-world12",
  storageBucket: "tour-the-world12.appspot.com",
  messagingSenderId: "674037387546",
  appId: "1:674037387546:web:7505b013555dd095e1dca3"
};

export default firebaseConfig;